import React, { useState, useEffect } from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ShoppingBasketTwoToneIcon from "@material-ui/icons/ShoppingBasketTwoTone";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";

// Components
import JcPortalSalesOrderHQTable from "./JcPortalSalesOrderHQTable";
import JcOnlineShopPaymentTable from "./JcOnlineShopPaymentTable";

//React Router (for getting parameters)
import { useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";

import { PDFDownloadLink } from "@react-pdf/renderer";
import { JcOnlineOrderPdf } from "../../../components/PDF/JcOnlineOrderPdf";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MessageBox from "../../../components/MessageBox/MessageBox";
import LoadingModal from "../../../components/Modal/LoadingModal";
//cookies
import { get_cookies, isLoggedIn } from "../../../components/Cookies/Cookies";
import Preloader from "../../../components/Preloader/Preloader";
import CountryTagOrderTable from "./CountryTagOrderTable";

const useStyles = makeStyles({
  card: {
    marginBottom: "1rem",
  },
  cardHeader: {
    borderBottom: "1px solid #33993312",
    padding: "1.3rem 24px 2rem 24px",
  },
  title: {
    marginTop: "0",
    color: "#339933",
    fontWeight: "700",
    fontSize: "1.1rem",
  },
  subTitle: {
    fontSize: "0.8rem",
    marginBottom: "0.5rem",
    fontWeight: "700",
    textTransform: "uppercase",
    color: "#9f9f9f",
  },
  infoContainer: {
    marginBottom: "2rem",
    backgroundColor: "#33993312",
    padding: "1rem",
    border: "1.5px solid #33993312",
    borderRadius: "5px",
  },
  infoTitle: {
    fontWeight: "700",
    fontSize: "14px",
  },
  infoContent: {
    fontSize: "14px",
  },
  buttonContainer: {
    textAlign: "right",
    "& button": {
      marginLeft: "0.5rem !important",
    },
  },
  wayBillbuttonContainer: {
    textAlign: "right",
    "& button": {
      marginLeft: "0.5rem !important",
    },
    marginTop: "1rem !important",
    marginRight: "1rem !important",
  },
  infoTotal: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "1rem",
  },
  infoTotalItem: {
    padding: "0.5rem 1rem",
    border: "1px solid #33993312",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    marginBottom: "0.5rem",
    fontWeight: "700",
  },
  infoTotalIcon: {
    marginRight: "0.5rem",
    color: "#4caf50 !important",
  },
  textarea: {
    width: "100%",
    marginTop: "1rem",
  },
});

const CountryTagUpgradeDetails = () => {
  const { id, flag } = useParams();
  const [soInfo, setSoInfo] = useState(null);
  const classes = useStyles();

  const [items, setItems] = useState([]); //data to display in item table
  const [payments, setPayments] = useState([]); //data to display in item table
  const [showPDF, setShowPdf] = useState(false);

  const [shipping, setShipping] = useState([]);
  const [warehouse, setWarehouse] = useState([]);
  const [upgDetails, setUpgDetails] = useState([]);
  const [packages, setPackage] = useState([]);
  const [shippingId, setShippingId] = useState("");
  const [shippingName, setShippingName] = useState("");
  const [warehouseId, setWarehouseId] = useState("");
  const [refno, setRefno] = useState("");
  const [isReleased, setIsReleased] = useState(false);
  const [grandtotal, setGrandTotal] = useState(0);
  let history = useHistory();

  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");
  //Message Box EOF
  //state for managing loading modal
  const [showModal, setShowModal] = useState(false);
  //state for disabling/enabling button
  const [btnDisabled, setBtnDisabled] = useState(true);
  // componentDidMount / document.ready ?
  useEffect(() => {
    data();
  }, []);

  const x = 0;
  useEffect(() => {
    //
    isLoggedIn();
  }, [x]);

  const selectShippingProps = {
    options: shipping,
    getOptionLabel: (option) => option.description,
  };

  const selectLocationProps = {
    options: warehouse,
    getOptionLabel: (option) => option.description,
  };

  useEffect(() => {
    if (warehouseId && soInfo) {
      setBtnDisabled(false); // re-enable
    } else {
      setBtnDisabled(true); // re-enable
    }
  }, [refno, shippingId, warehouseId, soInfo]);

  const data = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "get_details", {
        params: {
          idno: id,
          jc_u_idno: get_cookies("branchidno"),
          username: get_cookies("username"),
        },
      })
      .then((res) => {
        console.log(res.data);
        setPackage(res.data.countrytag_package[0]);
        setItems(res.data.countrytag_packagesitem);
        setSoInfo(res.data.distributor_info);
        setUpgDetails(res.data.countrytag_upgrade_details);
        setShipping(res.data.countrytag_shipping);
        setGrandTotal(parseFloat(res.data.countrytag_shipping[0].shipping_fee) + parseFloat(res.data.countrytag_upgrade_details.amount));
        // setWarehouse(res.data.get_location);
        console.log('??',res.data.countrytag_shipping);
        if (res.data.is_released.is_released == 0) {
          setIsReleased(true);
        } else {
          setIsReleased(false);
        }
        getWarehouse();

        // setPayments(res.data.data.customer_alloc);
        // if (res.data.data.order_details) {
        //   setShowPdf(true);
        // }
        //total_payment = res.data.data.cp_payments+res.data.data.b1t1_payments+res.data.data.ppv_payments+res.data.data.dragonpay_payments+res.data.data.paypanda_payments+res.data.data.asiapay_payments+res.data.data.ipay_payments;
      })
      .catch((error) => {
        // console.log(error.message);
      });
  };

  const getWarehouse = async () => {
		//get data for location/warehouse dropdown
		const res = await axios.get(process.env.REACT_APP_API_URL+'/get_warehouse_list');
		setWarehouse(res.data.data);

	};
  const release_online_orders = async () => {
    setBtnDisabled(true); // disable button to avoid multiple saves
    setShowModal(true); //show loading/please wait modal
    const formData = new FormData();
    // drno:8992
    // locid:8
    // shipid:1
    // shipping_name:TOKTOK
    // refnum:8ty87t8976tg8gh87u
    // totalamt:595
    //jc_u_idno:DAVAOHQ
    formData.append("idno", soInfo.idno);
    formData.append("itemlocid", warehouseId);
    formData.append("reference_no", upgDetails.reference_no);
    formData.append("username", get_cookies("username"));
    formData.append("jc_u_idno", get_cookies("branchidno"));

    await axios
      .post(process.env.REACT_APP_API_URL + "release_package", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (res) {
        setShowModal(false); //hide loading/please wait modal
        setShowMsgBox(true);
        setMsg("Successfully Released#" + id);
        setMsgType("success");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
          history.push("/sales/country-tag-upgrade");
        }, 2000);
      })
      .catch(function (error) {
        setShowModal(false); //hide loading/please wait modal
        setShowMsgBox(true);
        setMsg("Something went wrong: " + error);
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
        }, 2500);
      });
  };

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <ShoppingCartIcon />
        </div>
        {/* <img src={logo} width="100" height="50" alt="jc logo"/> */}
        <NavLink to={"/sales"}>
          <h2 style={{ color: "black" }}>Sales</h2>
        </NavLink>
        <ArrowForwardIosIcon
          style={{ paddingLeft: "10px", paddingRight: "10px" }}
        />
        <NavLink to={"/sales/country-tag-upgrade"}>
          <h2 style={{ color: "black" }}>Country Upgrade</h2>
        </NavLink>
        <ArrowForwardIosIcon
          style={{ paddingLeft: "10px", paddingRight: "10px" }}
        />
        <h2>Country Upgrade Details</h2>
      </div>
      {soInfo ? (
        <div className="page-container">
          <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType} />
          <LoadingModal showModal={showModal} />
          <Card className={classes.card}>
            <div className={classes.cardHeader}>
              <Grid
                container
                spacing={0}
                style={{ justifyContent: "flex-end" }}
              >
                {/* <Grid item xs={8}>
                  <div className={classes.title}>Online Sales Order View</div>
                </Grid> */}
                <Grid item xs={2} style={{ textAlign: "right" }}></Grid>
                <Grid item xs={2} className={classes.buttonContainer}></Grid>
              </Grid>
            </div>
            <CardContent>
              {soInfo ? (
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={12} lg={5}>
                    <div className={classes.infoContainer}>
                      <Grid
                        container
                        justifyContent="space-between"
                        spacing={2}
                      >
                        <Grid item xs={12} sm={12}>
                          <Grid container spacing={3}>
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              className={classes.infoTitle}
                            >
                              ID No:
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={8}
                              className={classes.infoContent}
                            >
                              {soInfo.idno}
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              className={classes.infoTitle}
                            >
                              Name:
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={8}
                              className={classes.infoContent}
                            >
                              {soInfo.fname} {soInfo.mname || " "}{" "}
                              {soInfo.lname}
                            </Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              className={classes.infoTitle}
                            >
                              Contact No:
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              className={classes.infoContent}
                            >
                              From
                              <Grid
                                item
                                xs={12}
                                sm={4}
                                className={classes.infoContent}
                              >
                                {upgDetails.old_contact}
                              </Grid>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              className={classes.infoContent}
                            >
                              To
                              <Grid
                                item
                                xs={12}
                                sm={4}
                                className={classes.infoContent}
                              >
                                {upgDetails.new_contact}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid
                              item
                              xs={4}
                              sm={4}
                              className={classes.infoTitle}
                            >
                              Address:
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              sm={4}
                              className={classes.infoContent}
                            >
                              From
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                className={classes.infoContent}
                              >
                                {upgDetails.old_address}
                              </Grid>
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              sm={4}
                              className={classes.infoContent}
                            >
                              To
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                className={classes.infoContent}
                              >
                                {upgDetails.new_address}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={5}>
                    <div className={classes.infoContainer}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} className={classes.infoTitle}>
                          Transaction Date:
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={8}
                          className={classes.infoContent}
                        >
                          {upgDetails.date_created}
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} className={classes.infoTitle}>
                          Payment Date:
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={8}
                          className={classes.infoContent}
                        >
                          {upgDetails.date_paid}
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} className={classes.infoTitle}>
                          Reference No:
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={8}
                          className={classes.infoContent}
                        >
                          {upgDetails.reference_no}
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} className={classes.infoTitle}>
                          PayPanda Reference No:
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={8}
                          className={classes.infoContent}
                        >
                          {upgDetails.payment_ref}
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                            <Grid
                              item
                              xs={4}
                              sm={4}
                              className={classes.infoTitle}
                            >
                              Account Type:
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              sm={4}
                              className={classes.infoContent}
                            >
                              From
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                className={classes.infoContent}
                              >
                                {upgDetails.old_atype}
                              </Grid>
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              sm={4}
                              className={classes.infoContent}
                            >
                              To
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                className={classes.infoContent}
                              >
                                {upgDetails.new_atype}
                              </Grid>
                            </Grid>
                          </Grid>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={5}>
                    <div className={classes.infoContainer}>
                      <Grid
                        container
                        justifyContent="space-between"
                        spacing={2}
                      >
                        <Grid item xs={6} sm={6}>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            className={classes.infoTitle}
                          >
                            Shipping Details:
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={4}
                            className={classes.infoTitle}
                          >
                            Delivery Type:
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={8}
                            className={classes.infoContent}
                          >
                            Pick Up
                          </Grid>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            className={classes.infoTitle}
                          >
                            Wholesale Set Details:
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={4}
                            className={classes.infoTitle}
                          >
                            Set Selected:
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={8}
                            className={classes.infoContent}
                          >
                            {packages.package_name}
                          </Grid>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                </Grid>
              ) : (
                <></>
              )}

              <h4>Item Details</h4>
              <CountryTagOrderTable items={items} />

              {shipping ? (
                <div className={classes.infoTotal}>
                  <div className={classes.infoTotalContent}>
                  <div className={classes.infoTotalItem}>
                      <ShoppingCartTwoToneIcon
                        className={classes.infoTotalIcon}
                      />
                      {"Upgrade Fee: " + numeral(upgDetails.amount).format("0,0.00")}
                    </div>
                    <div className={classes.infoTotalItem}>
                      <LocalShippingTwoToneIcon
                        className={classes.infoTotalIcon}
                      />
                      {"Shipping: " +
                        numeral(shipping.shipping_fee).format("0,0.00")}
                    </div>
                    <div className={classes.infoTotalItem}>
                      <ShoppingCartTwoToneIcon
                        className={classes.infoTotalIcon}
                      />
                      {"Total: " + numeral(grandtotal).format("0,0.00")}
                    </div>
                    <div className={classes.infoTotalItem}>
                      {"Note: All payments are converted to PHP"}
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}

              {isReleased == true ? (
                <Grid container spacing={1}>
                  <Grid item xs={12} lg={6}>
                    <Autocomplete
                      {...selectLocationProps}
                      id="auto-complete-2"
                      autoComplete
                      includeInputInList
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          margin="normal"
                          label="Warehouse Location"
                          variant="outlined"
                        />
                      )}
                      onChange={(event, newValue) => {
                        if (!newValue == "" || !newValue == null) {
                          //console.log(newValue.description);
                          setWarehouseId(newValue.id);
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              ) : (
                <></>
              )}
            </CardContent>
          </Card>
          <div className={classes.buttonContainer}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                {showPDF && (
                  <PDFDownloadLink
                    document={
                      <JcOnlineOrderPdf
                        soInfo={soInfo}
                        items={items}
                        payments={payments}
                      />
                    }
                    fileName={"JcOnlineOrderPdf#" + id + ".pdf"}
                    style={{
                      textDecoration: "none",
                      padding: "6px 8px 10px",
                      color: "#fff",
                      display: "inline-block",
                      marginBottom: "7px",
                      fontFamily: "Ubuntu",
                      backgroundColor: "#339933",
                      border: "1px solid #339933",
                      borderRadius: "4px",
                    }}
                  >
                    {({ blob, url, loading, error }) =>
                      loading ? "Loading document..." : "Print DR"
                    }
                  </PDFDownloadLink>
                )}
                {isReleased != false ? (
                  <Button
                    disabled={btnDisabled}
                    onClick={() => {
                      release_online_orders();
                    }}
                    variant="contained"
                    color="primary"
                  >
                    Release
                  </Button>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
          </div>
        </div>
      ) : (
        <Preloader />
      )}
    </div>
  );
};

export default CountryTagUpgradeDetails;
